import { render, staticRenderFns } from "./TeknikDestek.vue?vue&type=template&id=12b5103d&scoped=true&"
import script from "./TeknikDestek.vue?vue&type=script&lang=js&"
export * from "./TeknikDestek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5103d",
  null
  
)

export default component.exports